<div class="flex basis-full">
  <h1 class="text-left basis-full">{{ "ADMIN.CREATEEDITTRIAL" | appString }} {{this.trialData.trialNumber}}  </h1>
  <div class="text-right justify-end content-center basis-full">
    <button (click)="setEditMode()" [disabled]="!isReadOnly">{{ "GENERAL.EDIT" | appString }}</button>
    <button routerLink="/admin/">{{ "GENERAL.BACK" | appString }}</button>
    <button (click)="save()" [disabled]="isReadOnly">{{ "GENERAL.SAVE" | appString }}</button>
  </div>
</div>

<div class="flex w-[550px]">
  <div class="mat-elevation-z8 justify-center justify-items-center text-center w-full gap-x-[3px] m-[10px] p-[10px] float-right grid items-center grid-cols-5 text-2xl">
    <div class="text-center">{{ "GENERAL.BATCH" | appString }}</div>
    <div class="text-center">{{ "GENERAL.SECTION" | appString }}</div>
    <div class="text-center">{{ "GENERAL.PEN" | appString }}</div>
    <div class="text-center">{{ "GENERAL.GROUP" | appString }}</div>
    <div class="text-center">{{ "GENERAL.FEEDSHORT" | appString }}</div>

    @for (row of trialData.repetitions; track row) {
      <mat-form-field class="w-full">
        <mat-list-item ><input class="" [disabled]="isReadOnly" matInput [(ngModel)]="row.batch"></mat-list-item>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-list-item><input class="inputItem" [disabled]="isReadOnly" matInput [(ngModel)]="row.section"></mat-list-item>
      </mat-form-field>
      <mat-form-field  class="w-full">
        <mat-list-item><input class="inputItem" [disabled]="isReadOnly" matInput [(ngModel)]="row.pen"></mat-list-item>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-list-item><input class="inputItem" [disabled]="isReadOnly" matInput [(ngModel)]="row.group"></mat-list-item>
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-list-item><input class="inputItem" [disabled]="isReadOnly" matInput [(ngModel)]="row.feed"></mat-list-item>
      </mat-form-field>
    }
  </div>
</div>
